import { FC, useMemo } from 'react'

import { useTranslation } from 'react-i18next'

import { PassengersValues } from 'pages/avia/purchase-form/model'

import { DOCUMENT, GENDER } from 'entities/user/module'

import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'
import citizenshipStore from 'shared/store/citizenship-store.ts'
import { ListBlock } from 'shared/ui/list-block'

import s from './styles.module.scss'

interface Props {
  passenger: PassengersValues
  title: string
  index: number
  subtitle?: string
}

export const RenderPassengerInfo: FC<Props> = ({
  passenger,
  title,
  index,
  subtitle,
}) => {
  const { t } = useTranslation()

  const optionsGender = [
    { name: GENDER.MALE, option: t('male') },
    { name: GENDER.FEMALE, option: t('female') },
  ]

  const typesDocuments = [
    { name: DOCUMENT.ID, option: t('id_passport') },
    { name: DOCUMENT.PASSPORT, option: t('passport') },
    { name: DOCUMENT.BIRTH_CERTIFICATE, option: t('birth_certificate') },
  ]

  const localizedCitizenship = useMemo(() => {
    return citizenshipStore.citizenshipAvia?.find(
      (item) => item.code === passenger.citizenship,
    )
  }, [passenger])

  return (
    <div className={s.container}>
      <ListBlock
        key={'list' + index}
        title={title}
        subtitle={subtitle}
        list={[
          {
            label: t('type_passport'),
            value:
              typesDocuments.filter(
                (passport) => passport.name === passenger?.passport,
              )[0]?.option || '',
          },
          {
            label: t('last_name'),
            value: passenger?.lastName,
          },
          {
            label: t('first_name'),
            value: passenger?.firstName,
          },
          // {
          //   label: t('middle_name'),
          //   value: passenger?.doesMiddleName
          //     ? passenger?.middleName || '-'
          //     : '-',
          // },
          {
            label: t('gender'),
            value: optionsGender.filter(
              (gender) => gender.name === passenger?.gender,
            )[0]?.option,
          },
          {
            label: t('birth_day'),
            value:
              passenger?.dateOfBirth &&
              dateFormat(passenger?.dateOfBirth, DATE_FORMAT_LIST.FULL_DATE),
          },
          {
            label: t('citizenship'),
            value: localizedCitizenship?.country,
          },
          {
            label: t('serial_documents'),
            value: passenger?.serialDocuments,
          },
          {
            label: t('expiration_date'),
            value:
              passenger?.documentExpirationDate &&
              dateFormat(
                passenger?.documentExpirationDate,
                DATE_FORMAT_LIST.FULL_DATE,
              ),
          },
        ]}
      />
    </div>
  )
}
